import Image0 from "./images/Image0";

export default function EnclosedOlcaLogo() {
    return (
      <div className="enclosed-olca-logo">
        <Image0></Image0>
      </div>
    );
  }